/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ResponseForm = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'number',
    isRequired: true,
},
        isStandard: {
    type: 'boolean',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
    },
};